import { doHttp } from '../util/common'
import { HTTP_TYPE_GET, HTTP_TYPE_POST } from '../util/constants'

/**
 * 发布贸易
 * @param params
 * @returns {*}
 */
export function apiIntentionJournalList (page, rows) {
  let params = {
    page,
    rows
  }
  return doHttp('/intention/v1/authApi/getIntentionJournalList', HTTP_TYPE_POST, params)
}



// WEBPACK FOOTER //
// ./src/api/intention.js